<template>
  <div
    :class="{ 'inline-read-more--open': open }"
    class="inline-read-more"
  >
    <div class="inline-read-more__content">
      <slot />
    </div>
    <div class="inline-read-more__overlay">
      <span class="inline-read-more__pre">.. </span>
      <button
        type="button"
        class="inline-read-more__toggle"
        aria-hidden="true"
        @click="open = !open"
      >
        <span>{{ buttonText }}</span>
        <IconArrow class="icon icon--arrow" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  more: {
    type: String,
    default: () => {
      const { t } = useI18n({ useScope: 'global' })
      return t('Read more')
    },
  },
  less: {
    type: String,
    default: () => {
      const { t } = useI18n({ useScope: 'global' })
      return t('Collapse')
    },
  },
})

const open = ref(false)

const buttonText = computed(() => {
  return open.value ? props.less : props.more
})
</script>

<style src="~layers/app/components/Ui/InlineReadMore.css" />
